import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useAuthStore } from 'context/AuthStore'

export function ImportTouchDesk({ touch, desktop, children }) {
  const { authStore } = useAuthStore()
  const [Component, setComponent] = useState(null)
  const importCallback = authStore.isMobile ? touch : desktop

  useEffect(() => {
    importCallback()?.then(componentDetails => {
      setComponent(componentDetails)
    })
  }, [importCallback])

  return children(Component ? Component.default : () => null)
}
ImportTouchDesk.propTypes = {
  touch: PropTypes.func.isRequired,
  desktop: PropTypes.func.isRequired
}
